import { render, staticRenderFns } from "./idle-state.vue?vue&type=template&id=8b59f976&scoped=true"
import script from "./idle-state.vue?vue&type=script&lang=js"
export * from "./idle-state.vue?vue&type=script&lang=js"
import style0 from "./idle-state.vue?vue&type=style&index=0&id=8b59f976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b59f976",
  null
  
)

export default component.exports